var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-steps',{staticStyle:{"width":"60%"},attrs:{"current":0,"size":"small"}},_vm._l((_vm.stepsData.slice(0, 3)),function(item,index){return _c('a-step',{key:index,attrs:{"title":item.title}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }